import { createContext, type FC, type ReactNode } from 'react';

export type ServerVarsContextType = {
    isDesktop?: boolean | null;
    isMobile?: boolean | null;
    isTablet?: boolean | null;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({
    isDesktop: null,
    isMobile: null,
    isTablet: null,
});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType & { children: ReactNode }> = ({
    children,
    isDesktop,
    isMobile,
    isTablet,
}) => {
    return (
        <ServerVarsContext
            value={{
                isDesktop,
                isMobile,
                isTablet,
            }}
        >
            {children}
        </ServerVarsContext>
    );
};
